import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {BackgroundImageControlLabels} from '../../BackgroundImageControlLabels';
import {ContainerBuiltInControl} from '../ContainerBuiltInControl';

export abstract class ContainerBackgroundImageBuiltInControl extends ContainerBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.CONTAINER].IMAGE_CONTAINER;
  }

  public getLabels(): BackgroundImageControlLabels | undefined {
    return undefined;
  }
}
